import Contact from '../components/Contact'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import React, { useEffect } from 'react'
import { gql, GraphQLClient } from "graphql-request";
import { useState } from 'react';
import { Helmet } from 'react-helmet';







const MY_QUERY = gql`
query MyQuery {
    termsOfUses {
      id
      descriptions {
        html
      }
    }
  }
  
`;

function TermsOfUse() {
    const [data, setData] = useState(null);

    useEffect(() => {
      const client = new GraphQLClient(
        "https://api-us-east-1-shared-usea1-02.hygraph.com/v2/clgchterx4bkb01ui1t3baxyk/master"
      );
      const fetchData = async () => {
        const data = await client.request(MY_QUERY);
        setData(data);
      };
      fetchData();
    }, []);
  
    if (!data) return <div>Loading...</div>;
    return (
      <div className='relative z-0 bg-primary'>
        <Helmet>
<title>Terms Of Use - The Designsinc.</title>
</Helmet>
      <div className=''>
        <Navbar />
        <div className='left-auto right-auto items-center justify-center px-48'>
          {/** Contact Section from components comes through */}
          <div className='relative z-0 pt-32 pb-10 '>
          {data.termsOfUses.map((post) => (
            <div className="" dangerouslySetInnerHTML={{__html:post.descriptions.html}} />

          ))}
         
        </div>
          </div>
      </div>
     
      <Footer />
  
    </div>
    )
  }
  

export default TermsOfUse